<template>
    <div class="bg-[#2a2a36] text-white">
      <!-- Primera fila: Ícono -->
      <div class="flex justify-center py-4">
        <img src="../assets/img/logo.png" alt="Icono" class="h-32 w-32">
      </div>
      <!-- Segunda fila: Menú -->
      <div class="flex justify-center py-2">
        <ul class="flex space-x-8">
          <li>
            <router-link class="text-xl font-bold hover:text-gray-400"  to="/"  active-class="active">Inicio</router-link>
          </li>
          <li>
            <router-link class="text-xl font-bold hover:text-gray-400"  to="/nosotros"  active-class="active">Nosotros</router-link>
          
          </li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NavbarComponent',
  };
  </script>
  
  <style scoped>
  .active {
    @apply border-b-4 border-gray-300; /* Puedes personalizar esta clase según tus necesidades */
}
  </style>